import { animate, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { API, DeviceFullDTO } from 'src/app/services/api/api';
import { ModalNavigationComponent } from 'src/app/services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from 'src/app/services/gui/modal/modal-navigation.service';
import { SbPairingResultComponent } from '../sb-pairing-result/sb-pairing-result.component';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-device-service',
  templateUrl: './sb-device-service.component.html',
  styleUrls: ['./sb-device-service.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SbDeviceServiceComponent implements OnInit, ModalNavigationComponent {
  loading: boolean;

  isInModalContext: boolean;

  mode: string;

  @Input()
  device: DeviceFullDTO;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService,
    public translate: TranslateService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  checkServiceDone() {
    this.api
      .ss_nm_Device_fulfillServiceRequest(this.device.id)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {
          this.checkSuccess();
        },
        error: () => {
          this.checkFail();
        },
      });
  }

  goBack() {
    this.modalNavigation.goBack();
  }

  getServiceText() {
    if (this.device?.serviceRequest?.message) {
      return this.device.serviceRequest.message;
    }
    return 'Offline';
  }

  checkFail() {
    this.modalNavigation.navigate(SbPairingResultComponent, {
      device: this.device,
      mode: 'SERVICE',
      success: false,
      message: this.translate.instant('lang.devices.deviceServiceCheckFailed'),
    });
  }

  checkSuccess() {
    this.modalNavigation.clearAndNavigate(SbPairingResultComponent, {
      device: this.device,
      mode: 'SERVICE',
      success: true,
      message: this.translate.instant('lang.devices.deviceServiceChecked'),
    });
  }
}
